export default {
  "code": "es",
  "title": "Español",
  "flag": "🇪🇸",
  "meta": {
    "index": {
      "title": "Mejores trabajos académicos.\n10 veces más rápido con IA.",
      "description": "Sin Hesse: Miras una página en blanco durante horas.\nCon Hesse: Generas textos excelentes con un clic."
    },
    "profile": {
      "title": "Configuración del perfil",
      "description": "Controla fácilmente la configuración de tu perfil"
    }
  },
  "templates": {
    "summarize-text": {
      "headline": "",
      "description": ""
    },
    "find-topic": {
      "headline": "Encontrar tema",
      "description": "Lluvia de ideas para obtener más ideas para un tema de trabajo académico."
    },
    "find-sources": {
      "headline": "Encontrar fuentes",
      "description": "Busca fuentes académicas que podrían ser relevantes para el tema."
    },
    "source-qa": {
      "headline": "Chat de fuentes",
      "description": "Responde preguntas sobre una fuente. Agrega un enlace a un sitio web, un documento en línea, o sube un archivo desde tu computadora."
    },
    "write-outline": {
      "headline": "Crear esquema",
      "description": "Crea un esquema aproximado para un tema de trabajo académico."
    },
    "write-introduction": {
      "headline": "Escribir introducción",
      "description": "Crea una introducción para un trabajo académico."
    },
    "write-chapter": {
      "headline": "Escribir capítulo",
      "description": "Escribe un capítulo para un trabajo académico."
    },
    "write-essay": {
      "headline": "Escribir ensayo",
      "description": "Escribe un trabajo académico completo."
    },
    "proofreading": {
      "headline": "Corrección",
      "description": "Corrige un texto."
    },
    "freestyle": {
      "headline": "Freestyle",
      "description": "Escribe cualquier texto."
    },
    "summarize-document": {
      "headline": "",
      "description": ""
    },
    "summarize-article": {
      "headline": "",
      "description": ""
    },
    "summarize-source": {
      "headline": "",
      "description": ""
    }
  },
  "validations": {
    "required": "{_field_} es un campo obligatorio",
    "min": "{_field_} debe tener al menos {length} caracteres",
    "max": "{_field_} no debe tener más de {length} caracteres"
  },
  "buttons": {
    "close": "Cerrar",
    "upgrade": "actualizar",
    "get_more_words": "Obtener más palabras ahora",
    "login": "iniciar sesión",
    "logout": "cerrar sesión",
    "cancel": "Cancelar",
    "yes": "Sí",
    "no": "No",
    "tryout": "probar",
    "add": "agregar",
    "report": "reportar",
    "save": "guardar",
    "edit": "editar",
    "copy": "copiar",
    "delete": "eliminar",
    "generate": "generar",
    "signup": "registrarse",
    "continue": "continuar",
    "submit": "enviar",
    "add_source": "Agregar fuente",
    "select_source": "Seleccionar fuente",
    "new_document": "Nuevo Documento",
    "back": "atrás",
    "local_document": {
      "title": "Documento PDF desde mi computadora",
      "type": "Subir documento PDF"
    },
    "web_document": {
      "title": "Enlace web, por ejemplo Wikipedia",
      "type": "Agregar enlace web"
    },
    "done": "hecho",
    "discard": "descartar",
    "ask": "Preguntar",
    "flag": "Marcar"
  },
  "labels": {
    "missing_subscription": "Necesitas una suscripción para usar esta herramienta.",
    "booked": "tu plan actual",
    "account": "Cuenta",
    "subscription": "Suscripción",
    "name": "Nombre",
    "email": "Correo electrónico",
    "limit": "Límite",
    "settings": "Configuración",
    "words": "Palabras",
    "usage": "Uso",
    "extra_words": "incluyendo {words} palabras extra",
    "show_all_applications": "Mostrar todas las aplicaciones",
    "show_all": "Mostrar todo",
    "start_page": "Ir a la página de inicio",
    "is_favorite": "En favoritos",
    "add_favorite": "Agregar a favoritos",
    "wordlimit_reached": "Límite de palabras alcanzado",
    "wordlimit_increase": "Aumentar límite de palabras ahora",
    "contact": "Abrir contacto",
    "history": "Historial",
    "show_history": "mostrar historial",
    "inprint": "Aviso legal",
    "dataregulation": "Protección de datos",
    "tos": "Términos de servicio",
    "month": "mes",
    "cancel_anytime": "Cancelar en cualquier momento",
    "try_now": "probar gratis ahora",
    "book_again": "Reservar de nuevo",
    "book": "Cambiar plan",
    "upgrade_to": "Actualizar a {product}",
    "copied_link": "Enlace copiado",
    "subject": "Asunto",
    "generated_by_hesse": "Generado por Hesse en 3 segundos.",
    "use_template": "usar plantilla",
    "show_mode": "mostrar más",
    "upload": "subir",
    "optional": "opcional",
    "my_documents": "Mis Documentos",
    "my_sources": "Mis Fuentes",
    "add_source": "Agregar fuente",
    "select_source": "Seleccionar fuente",
    "page": "Página {page}",
    "pages": "Páginas {from} - {to}",
    "unknown_author": "Autor desconocido",
    "checker_results": "Resultados del detector de IA",
    "human": "humano",
    "citation_style": "Estilo de cita",
    "started_at": "comenzó en",
    "ends_at": "termina en",
    "cancel_subscription": "cancelar suscripción",
    "file_too_large": "Archivo demasiado grande (máx. 50 MB), intenta dividirlo",
    "relevance": "Relevancia",
    "relevance_help": "La relevancia mide qué tan bien la fuente se ajusta al tema buscado en términos de contenido.",
    "quality": "Calidad",
    "quality_help": "La calidad mide qué tan buena es la fuente tanto en contenido como en forma.",
    "trustworthiness": "Confiabilidad",
    "trustworthiness_help": "La confiabilidad mide, principalmente basándose en los metadatos de la fuente, qué tan confiable es.",
    "high": "alta",
    "normal": "normal",
    "low": "baja",
    "features": "Características",
    "monthly": "Mensual",
    "year": "año",
    "yearly": "Anual",
    "save_50": "ahorrar 50%",
    "pay_amount_per_period": "Paga {amount}/{period}.",
    "focus_of_the_chapter": "Enfoque del capítulo",
    "reason": "Razón",
    "summary": "Resumen",
    "raw_text": "Texto sin formato",
    "topic": "Tema",
    "essay_banner_part_1": "🚨 <i>Esta función será deshabilitada pronto</i><br/>Para <strong>mejores resultados de generación</strong> y <strong>más control granular</strong>, recomendamos usar la herramienta",
    "essay_banner_part_2": "y generar tu ensayo <strong>capítulo por capítulo</strong>. ¡Pruébala para una experiencia de escritura más fluida y personalizada! ✨📖",
    "language": "Idioma",
    "language_english_hint": "Muchos artículos académicos se publican en inglés. Te recomendamos buscar también fuentes en inglés para encontrar más resultados relevantes.",
    "length": "Longitud",
    "length_options": [
      {
        "text": "corto (4 párrafos)",
        "value": "short"
      },
      {
        "text": "normal (6 párrafos)",
        "value": "normal"
      },
      {
        "text": "largo (8 párrafos)",
        "value": "long"
      }
    ],
    "source_type_options": [
      {
        "label": "Búsqueda de fuentes automática",
        "value": "quality"
      },
      {
        "label": "Trabajar con tus propias fuentes",
        "value": "quality_with_sources"
      }
    ],
    "sources": "Fuentes",
    "source": "Fuente",
    "open_access": "Acceso abierto",
    "show_only_open_access": "Mostrar solo fuentes de acceso abierto",
    "essay_outline_options": [
      {
        "value": "generate",
        "label": "Genera un esquema para mí"
      },
      {
        "value": "provide",
        "label": "Usar mi propio esquema"
      }
    ],
    "your_outline": "Tu esquema",
    "year_of_publication": "Año de publicación",
    "outline": "Esquema",
    "summary_type": "Tipo de resumen",
    "summary_type_options": [
      {
        "label": "Informativo",
        "value": "informative"
      },
      {
        "label": "Descriptivo",
        "value": "descriptive"
      },
      {
        "label": "Crítico",
        "value": "critical"
      },
      {
        "label": "Abstracto",
        "value": "abstract"
      }
    ],
    "original_text": "Texto original",
    "maintenance": "Nuestros servicios están en mantenimiento por un momento. ¡Lo sentimos por las molestias y gracias por tu comprensión!",
    "something_wrong": "Siempre verifica las citas. ¿Algo está mal?",
    "bad_citation_title": "Reportar cita",
    "bad_citation_text": "Dinos qué crees que está mal con la cita que marcaste.",
    "thanks_for_report": "¡Gracias por ayudarnos a mejorar Hesse AI!",
    "no_sources_found": "No se encontraron fuentes. Intenta ajustar tu tema o los filtros de búsqueda.",
    "user_instruction": "Instrucciones personalizadas",
    "document": "Documento",
    "article": "Artículo",
    "study_program": "Programa de estudios",
    "study_subject": "Materia",
    "interests": "Intereses",
    "used_for_source_search": "Usado para búsqueda de fuentes",
    "not_used_for_source_search": "No usado para búsqueda de fuentes",
    "headline": "Enfoque del capítulo",
    "chapter_length": "Longitud",
    "chapter_length_options": [
      {
        "text": "corto (4 párrafos)",
        "value": "short"
      },
      {
        "text": "normal (6 párrafos)",
        "value": "normal"
      },
      {
        "text": "largo (8 párrafos)",
        "value": "long"
      }
    ],
    "source_chat_placeholder": "Resume esta fuente para mí...",
    "publish_year": "Año de publicación",
    "text": "Texto original",
    "prompt": "Instrucción"
  },
  "blog": {
    "written_by": "Escrito por",
    "read_article": "Leer artículo"
  },
  "stages": {
    "searching_sources": "Buscando fuentes",
    "filtering_sources": "Filtrando fuentes",
    "processing_sources": "Procesando fuentes",
    "writing_plan": "Creando plan de escritura",
    "writing_chapter": "Escribiendo capítulo"
  },
  "source": {
    "select": {
      "empty": {
        "headline": "Nada aquí todavía.",
        "hint": "Puedes marcar fuentes en 'Encontrar fuentes' y usarlas en varias herramientas."
      }
    },
    "table": {
      "name": "Nombre",
      "type": "Tipo",
      "created_at": "Creado en"
    },
    "type": {
      "document": "Documento",
      "website": "Artículo",
      "paper": "Artículo"
    },
    "snippet": {
      "hint": "El texto del documento original puede estar extrañamente formateado. En la mayoría de los casos, esto no es un problema para la IA. Pero estamos trabajando en mejorar esto."
    },
    "hint": {
      "not_usable": "Las fuentes que aún no han sido procesadas no se consideran al escribir."
    },
    "processing": "siendo procesado...",
    "recent": "usado recientemente",
    "bookmark": "marcar",
    "bookmarked": "marcado",
    "direct_pdf_access": "Acceso directo a PDF",
    "source_info": "Información de la fuente"
  },
  "placeholders": {
    "url": "https://www.nature.com/articles/s41586-023-06447-0",
    "topic": "Desarrollo urbano sostenible: Smart Cities entre innovación y justicia social",
    "focus_of_the_chapter_legacy": "Transformación digital",
    "focus_of_the_chapter": "¿Cómo titularías tu capítulo?",
    "outline": "I. La evolución de las Smart Cities\n   A. De la ciudad tradicional a la ciudad conectada\n      1. Definición y conceptos fundamentales\n      2. Impulsores tecnológicos del desarrollo\n   B. La sostenibilidad como paradigma central\n      1. Monitoreo y protección ambiental\n      2. Optimización de recursos a través del IoT\nII. Dimensiones sociales de la digitalización\n   A. Inclusión y accesibilidad\n   B. Soberanía de datos de los ciudadanos\n   C. Superar la brecha digital",
    "original_text": "La física cuántica revoluciona nuestra comprensión de la realidad en el nivel más fundamental.\nA diferencia de la física clásica, donde las partículas son partículas u ondas, la mecánica cuántica muestra que la materia puede tener ambas propiedades simultáneamente.\nEl famoso experimento de la doble rendija demuestra esta dualidad de manera impresionante: fotones individuales crean un patrón de interferencia como si pasaran por ambas rendijas al mismo tiempo.\nEl entrelazamiento cuántico, descrito por Einstein como 'acción fantasmal a distancia', permite que las partículas permanezcan instantáneamente conectadas a grandes distancias.\nEstos fenómenos forman la base de tecnologías revolucionarias como las computadoras cuánticas y la criptografía cuántica...",
    "chat": "¿Qué aplicaciones prácticas surgen de esto?",
    "report_citation": "Esta cita es inexacta porque...",
    "user_instruction": "Analiza el impacto de la digitalización en las profesiones artesanales tradicionales y muestra enfoques de solución",
    "topic_placeholder": "Inteligencia artificial en la educación: Oportunidades y desafíos",
    "outline_placeholder": "I. Introducción a la educación apoyada por IA\n   A. Definición y fundamentos\n      1. ¿Qué es la IA en el contexto educativo?\n      2. Desarrollos y tendencias actuales\n   B. Potenciales para el aprendizaje personalizado\n      1. Sistemas de aprendizaje adaptativo\n      2. Apoyo individual\nII. Desafíos y consideraciones éticas\n   A. Protección de datos y privacidad\n   B. Brecha digital y accesibilidad",
    "document_placeholder": "Investigación_IA_Educación.pdf",
    "article_placeholder": "https://www.nature.com/articles/s41586-023-06259-2",
    "study_program_placeholder": "Educación digital y pedagogía de medios",
    "study_subject_placeholder": "Humanidades digitales",
    "interests_placeholder": "Sostenibilidad, Blockchain, Economía creativa",
    "headline_placeholder": "Plataformas de aprendizaje apoyadas por IA",
    "source_chat_placeholder": "Resume esta fuente para mí...",
    "random_text_placeholder": "El futuro del trabajo enfrenta un cambio revolucionario a través de la integración de la inteligencia artificial y las tecnologías de automatización.\nMientras que los trabajos tradicionales están siendo reemplazados por robots y sistemas de IA, simultáneamente emergen campos profesionales completamente nuevos y oportunidades de carrera.\nLa capacidad de educación continua y adaptación a nuevas tecnologías se está convirtiendo en una competencia clave en el mundo laboral moderno.\nEl trabajo remoto y los modelos de trabajo flexibles están ganando importancia y cambiando fundamentalmente cómo definimos la colaboración y la productividad.\nLas empresas deben lidiar cada vez más con preguntas de ética digital, protección de datos y el equilibrio entre eficiencia y creación de valor humano..."
  },
  "groups": {
    "research": "Investigación",
    "essay": "Ensayo",
    "misc_tools": "Otras herramientas"
  },
  "flows": {
    "summarize": {
      "headline": "Resumir",
      "description": "¿Qué te gustaría resumir?"
    },
    "titles": {
      "summarize_document": "Documento",
      "summarize_text": "Texto",
      "summarize_article": "Artículo",
      "summarize_source": "Fuente"
    },
    "prefill": {
      "summarize_document": "Resume el contenido de este documento para mí."
    }
  },
  "messages": {
    "get_more_words": "Obtener más palabras ahora",
    "contact_success": "¡Gracias por tu mensaje!",
    "error": "Algo no funcionó. Por favor intenta de nuevo más tarde.",
    "updated": "{field} actualizado",
    "failed_to_update": "No se pudo actualizar \"{field}\", por favor intenta nuevamente",
    "generic_error": "Tu solicitud falló – inténtalo más tarde o contacta al soporte 😔",
    "upload_error_generic": "No pudimos procesar una de tus fuentes – reemplázala o usa nuestras fuentes automáticas",
    "upload_error_url": "No pudimos procesar la URL proporcionada – si es un PDF, intenta subirlo directamente como archivo",
    "upload_error_high_no_content": "No pudimos extraer suficiente información relevante de una de tus fuentes – reemplázala o usa nuestras fuentes automáticas",
    "no_snippets_found_error": "No se encontraron suficientes fuentes para los datos proporcionados – intenta de nuevo con otros datos",
    "account_deletion_error": "No puedes eliminar tu cuenta mientras tengas una suscripción activa. Cancélala primero."
  },
  "validation": {
    "required": "{_field_} es un campo obligatorio",
    "min": "{_field_} debe tener al menos {length} caracteres",
    "max": "{_field_} no puede tener más de {length} caracteres",
    "maxarray": "{_field_} tiene demasiados caracteres"
  },
  "domains": {
    "cancellation": {
      "headline": "Cancelar suscripción",
      "description": "¿Realmente quieres cancelar tu suscripción? ¿Por qué razón quieres cancelar?",
      "options": [
        {
          "text": "Trabajo completado",
          "value": "work_completed"
        },
        {
          "text": "No satisfecho con el producto",
          "value": "unsatisfied_with_product"
        },
        {
          "text": "Demasiado caro",
          "value": "price_performance_issue"
        },
        {
          "text": "Problemas técnicos",
          "value": "technical_issues"
        },
        {
          "text": "Encontré otro proveedor",
          "value": "found_other_provider"
        },
        {
          "text": "No sabía que era una suscripción",
          "value": "unaware_of_subscription"
        },
        {
          "text": "Otro",
          "value": "other"
        }
      ]
    },
    "try": {
      "headline": "Hesse Pro",
      "loading": "Estamos activando tu cuenta de prueba..."
    },
    "openai": {
      "status": {
        "unreliable": "Actualmente tenemos alta carga del servidor. Puede haber interrupciones. Si algo no funciona, por favor intenta de nuevo más tarde.",
        "working_on_fix": "Puede haber interrupciones actualmente. Ya estamos trabajando en una solución. Por favor intenta de nuevo más tarde."
      }
    },
    "ai_checker": {
      "hint": "Los detectores de IA son herramientas que verifican textos para contenido de IA. Puedes hacer clic en las tarjetas para ir a la herramienta correspondiente."
    },
    "cookie": {
      "headline": "Cookies 🍪",
      "text1": "Al hacer clic en \"Aceptar todas las cookies\", aceptas el almacenamiento de cookies en tu dispositivo para mejorar la navegación del sitio, analizar el uso del sitio y ayudar en nuestros esfuerzos de marketing.",
      "analytics": "Cookies de rendimiento",
      "analytics_text": "Estas cookies nos permiten analizar el comportamiento del usuario en Hesse.ai de forma anónima para optimizar la experiencia del usuario.",
      "marketing_text": "Estas cookies pueden ser establecidas por nuestros socios publicitarios a través de nuestro sitio web. Pueden ser utilizadas por esas empresas para crear un perfil de tus intereses y mostrarte anuncios relevantes en otros sitios.",
      "marketing": "Cookies de marketing",
      "technical": "Cookies funcionales",
      "technical_text": "Estas cookies son necesarias para asegurar un uso seguro y confiable.",
      "consent": "Aceptar todas las cookies",
      "save": "Guardar preferencias",
      "decline": "Rechazar"
    },
    "write": {
      "save_changes": "Guardar cambios",
      "keep_writing": "Seguir escribiendo"
    },
    "feedback": {
      "title": "Danos retroalimentación adicional",
      "description": "Estamos constantemente tratando de mejorar nuestros resultados. Por favor describe qué te gustaría que haya cambiado."
    },
    "report": {
      "title": "¿Reportar esta respuesta?",
      "reason": "Razón del reporte",
      "description": "Reporta resultados que contengan contenido crítico o ilegal.",
      "result_good": "El resultado es útil",
      "result_bad": "El resultado no es útil"
    },
    "pricing": {
      "monthly_wordlimit": "{limit} palabras por mes",
      "increase_limit": "Aumentar límite",
      "wordlimit_reached": "Has alcanzado tu límite de palabras",
      "wordlimit_reached_description": "La cuota para este mes se ha agotado. Si quieres continuar, necesitas aumentar tu límite.",
      "wordlimit_nearly_reached": "Tus palabras están casi agotadas.",
      "get_more_words": "Obtener más palabras",
      "get_more_words_description": "Los textos de alta calidad requieren mucha potencia de cómputo. Eso es caro.<br /> Pero hemos hecho nuestros paquetes lo más asequibles posible.",
      "error_title": "La reserva desafortunadamente no funcionó.",
      "error_description": "Contáctanos - Te ayudaremos inmediatamente.",
      "text1": "¿Cuánto son 10,000 palabras?",
      "text2": "Eso fueron 10,000 palabras",
      "referral_title": "¿No puedes decidirte aún?",
      "referral_title2": "¿Necesitas más palabras?",
      "referral_description": "Comparte tu enlace con amigos. Recibirás 1,000 palabras gratis por cada nuevo registro a través de tu enlace."
    },
    "survey": {
      "title": "¿Cómo calificas Hesse.ai?",
      "suggestions": "¿Qué cambiarías?",
      "success_title": "¡Gracias por tu retroalimentación!",
      "success_text": "Nos ayudas a mejorar continuamente Hesse.ai",
      "abort": "no calificar"
    },
    "cards_hint": {
      "title": "Las tarjetas de memoria están ahora disponibles",
      "subtitle": "¿Crear automáticamente <strong>tarjetas de memoria</strong> de tu <strong>conferencia</strong>?",
      "cta": "Crear tarjetas de memoria ahora"
    },
    "share_modal": {
      "headline": "Compartir Hesse - obtener palabras gratis"
    },
    "login_page": {
      "loading": "Iniciando sesión...",
      "error": "El inicio de sesión no fue exitoso",
      "delayed": "El inicio de sesión está tomando más tiempo de lo habitual.<br /> Por favor verifica tu conexión a internet e intenta de nuevo si es necesario.",
      "try_again": "Iniciar sesión de nuevo"
    },
    "sidebar": {
      "create_own_application": "Crear tu propia aplicación",
      "hesse_cards": "Tarjetas Hesse 🃏",
      "all_applications": "Todas las aplicaciones",
      "favourites": "Mis favoritos"
    },
    "profile": {
      "title": "Configuración del perfil",
      "limit": "Límite",
      "used_tokens": "Tokens usados",
      "get_more_words": "Obtener más palabras ahora",
      "no_subscription": "Aún no tienes una suscripción.",
      "upgrade_now": "Actualizar ahora",
      "manage_subscription": "Gestionar suscripción",
      "delete_account": "Eliminar cuenta",
      "deleted": "Tu cuenta ha sido eliminada. Si inicias sesión, se creará una nueva cuenta."
    },
    "contact": {
      "title": "Contacto",
      "subtitle": "Contáctanos"
    },
    "error_page": {
      "title404": "404 - Página no encontrada",
      "title": "Ha ocurrido un error",
      "text": "Ayúdanos a mejorar Hesse.ai.<br /> Describe brevemente qué hiciste inmediatamente antes de que apareciera esta página.",
      "cta": "Ir a la página de inicio"
    },
    "success_page": {
      "loading": "cargando...",
      "booking_success": "¡Tu reserva fue exitosa!",
      "booked_product": "Has reservado {productName}",
      "start_now": "Comenzar ahora"
    }
  },
  "typewriter": {
    "writeEssay": [
      "Generando textos...",
      "Encriptando textos...",
      "Verificación de plagio...",
      "Ejecutando herramientas de verificación de IA...",
      "Textos ya no rastreables ✔"
    ],
    "writeOutline": [
      "Generando textos...",
      "Encriptando textos...",
      "Verificación de plagio...",
      "Ejecutando herramientas de verificación de IA...",
      "Textos ya no rastreables ✔"
    ],
    "writeIntroduction": [
      "Generando textos...",
      "Encriptando textos...",
      "Verificación de plagio...",
      "Ejecutando herramientas de verificación de IA...",
      "Textos ya no rastreables ✔"
    ]
  },
  "loader": [
    "Evaluando tus entradas",
    "Agregando sal y pimienta",
    "Pedro, Pedro, Pedro",
    "Sacudiendo la varita mágica",
    "Llevando a tu mesa"
  ],
  "features": {
    "find-sources": {
      "headline": "Encontrar fuentes",
      "description": "Busca fuentes académicas que podrían ser relevantes para el tema."
    },
    "write-outline": {
      "headline": "Crear esquema",
      "description": "Crea un esquema aproximado para un tema de trabajo académico."
    },
    "write-chapter": {
      "headline": "Escribir capítulo",
      "description": "Escribe un capítulo para un trabajo académico."
    },
    "write-essay": {
      "headline": "Escribir ensayo",
      "description": "Escribe un trabajo académico."
    },
    "source-qa": {
      "headline": "Chat de fuentes",
      "description": "Responde preguntas sobre una fuente. Agrega un enlace a un sitio web o sube un archivo desde tu computadora."
    },
    "proofreading": {
      "headline": "Corrección",
      "description": "Corrige un texto."
    }
  }
}
